import { render, staticRenderFns } from "./VxInfoTitle.vue?vue&type=template&id=8d0df0b2&scoped=true"
import script from "./VxInfoTitle.vue?vue&type=script&lang=js"
export * from "./VxInfoTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0df0b2",
  null
  
)

export default component.exports